export function getElementParents(element) {
  const parents = [];
  let currentElement = element;

  while (currentElement && currentElement.parentNode) {
    let { parentNode } = currentElement;
    // If the parentNode is a ShadowRoot, we want to get the host element.
    if (parentNode instanceof ShadowRoot) parentNode = parentNode.host;
    parents.push(parentNode);
    currentElement = parentNode;
  }

  return parents;
}

export function getElementOffsetParents(element) {
  const offsetParents = [];
  let currentElement = element;

  while (currentElement && currentElement.offsetParent) {
    offsetParents.push(currentElement.offsetParent);
    currentElement = currentElement.offsetParent;
  }

  return offsetParents;
}
